import React, { useContext, useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { Tooltip } from "antd"
import { get, map } from "lodash"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"

//i18n
import i18n from "../../../i18n"
import languages from "../../../common/languages"
import GlobalState from "../../../contexts/GlobalState"

const LanguageDropdown = props => {
  const [state, setState] = useContext(GlobalState) //NOSONAR
  const [selectedLang, setSelectedLang] = useState("")
  const [selectedLangText, setSelectedLangText] = useState("")
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const currentLanguage = localStorage.getItem("i18nextLng")
    setSelectedLang(currentLanguage)
    changeLanguageText(currentLanguage)

    globalThis.addEventListener("storage", () => {
      const lang = localStorage.getItem("i18nextLng")
      setSelectedLang(lang)
      changeLanguageText(lang)
    })
  }, [])

  const changeLanguageText = lang => {
    if (lang.startsWith("fi")) {
      setSelectedLangText(get(languages, `fi.label`))
    } else if (lang.startsWith("sv")) {
      setSelectedLangText(get(languages, `sv.label`))
    } else {
      setSelectedLangText(get(languages, `en.label`))
    }
  }

  const changeLanguageAction = lang => {
    //set language as i18n
    i18n.changeLanguage(lang)
    localStorage.setItem("i18nextLng", lang)
    setState(state => ({ ...state, language: lang }))
    setSelectedLang(lang)
    setSelectedLangText(get(languages, `${lang}.label`))
    if (props.onChange != null) {
      props.onChange(lang)
    }
  }

  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <Tooltip title={props.t("Language")} trigger={["hover", "focus"]}>
          {props.showText ? (
            <DropdownToggle className="btn text-muted" tag="button">
              <i
                className="bx bx-globe me-2"
                style={{ verticalAlign: "middle" }}
              />
              {selectedLangText}
              <i className="mdi mdi-chevron-down text-dark ms-2" />
            </DropdownToggle>
          ) : (
            <DropdownToggle
              aria-haspopup="menu"
              aria-label={props.t("Language")}
              tag="button"
              className="btn header-item noti-icon focus-topbar"
            >
              <i id="" className="bx bx-globe align-middle" />
            </DropdownToggle>
          )}
        </Tooltip>
        <DropdownMenu className="dropdown">
          {map(Object.keys(languages), key => (
            <DropdownItem
              key={key}
              onClick={() => changeLanguageAction(key)}
              className={`notify-item ${
                selectedLang === key ? "active" : "none"
              }`}
            >
              <img
                src={get(languages, `${key}.flag`)}
                alt="Language"
                className="me-2"
                height="12"
              />
              <span className="align-middle">
                {get(languages, `${key}.label`)}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

LanguageDropdown.propTypes = {
  t: PropTypes.any,
  showText: PropTypes.bool,
  onChange: PropTypes.func,
}

export default withTranslation()(LanguageDropdown)
